import { useState } from 'react';
import { CustomDialogProps } from '@/dashboard/components/Dialog/index';
import PolicyModel from '@/dashboard/models/policys/PolicyModel';
import CancelConfirmView from './confirm';

type CancelPolicyDialogViewProps = CustomDialogProps & {
  policy: PolicyModel;
};
const CancelPauseDialog = (props: CancelPolicyDialogViewProps) => {
  const { close, policy } = props;

  return <CancelConfirmView policy={policy} close={close} />;
};

export default CancelPauseDialog;
